import moment from 'moment';

export default function home_tour() {
	
  var tour_id = $('#tour').data('tour-id');
  
  $.ajax({
    url: 'https://rest.bandsintown.com/artists/id_' + tour_id + '/events?app_id=45PRESS_GEORGIA_WEBSTER',
    method: 'GET',
    dataType: 'json',
    error: () => {
      alert('Error fetching events!');
    },
    success: data => {
      const events = $('#tour .tour-dates');
      let html = '';
      if (data.length) {
        var i = 0;
        for (let event of data) {
          i++;
          if (i > 7) break;
          let location = event.venue.location;

          html += '<div class="tour">';
          html += '<div class="tour-info">';
          html += '<div class="date">';
          html += moment(event.datetime).format('MMM') + ' ' + moment(event.datetime).format('D');
          // html += '<div class="tour-date__month">' + moment(event.datetime).format('MMM') + '</div>';
          // html += '<div class="tour-date__day">' + moment(event.datetime).format('D') + '</div>';
          // html += '<div class="tour-date__year">' + moment(event.datetime).format('YYYY') + '</div>';
          html += '</div>';
          // html += '<div class="title">Disney Princess – The Concert</div>';
          html += '<div class="location">' + location + '</div>';
          html += '<div class="venue">' + event.venue.name + '</div>';
          html += '</div>';
          html += '<div class="tour-action">';
          for (let offer of event.offers) {
            html += '<a href="' + offer.url + '" target="_blank">' + offer.type + '</a>';
          }
          html += '</div>';
          html += '</div>';
        }
        events.html(html);

      } else {
        events.html('No upcoming events.');
      }
    }
  });
	
}